import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const BlogCard = ({ post }) => {
  const id = post.sys.id;
  return (
    <div className="py-5 px-3 mb-5 border-b-2 border-b-slate-200">
      <div>
        <div>
          <div>
            <div className="mb-2 flex gap-4">
              <img
                className="h-10 w-10 rounded-full object-cover"
                src={post?.fields?.authorImage?.fields?.file.url}
                alt=""
              />
              <div>
                <p className="text-sm text-slate-700 font-semibold">
                  Abdulaziz
                </p>
                <p className="text-xs text-slate-400 font-semibold">
                  {moment(post?.fields?.createdOn).format("Do MMMM YYYY")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="md:grid md:grid-cols-6 md:mt-5">
          <div className="py-4 md:py-0 md:col-span-4">
            <div className="mt-4 md:mt-5 pr-5">
              <Link to={`/blog/${id}`}>
                <h2 className="text-lg md:text-2xl font-semibold text-slate-700 ">
                  {post?.fields?.title}
                </h2>
              </Link>
              <p className="flex gap-3 text-sm my-3 text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5 "
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
                  />
                </svg>
                <span>{post?.fields?.time} min read</span>
              </p>
            </div>
            <p className="text-sm md:text-[16px] text-gray-600 leading-relaxed md:pr-4 md:pt-2 text-left">
              {post?.fields?.description}
            </p>
          </div>
          <div className="md:col-span-2 py-2">
            <Link to={`/blog/${id}`}>
              <img
                src={post?.fields?.featuredImage?.fields?.file.url}
                alt="card pictute"
                className="w-full rounded-md object-cover"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="w-100 py-5">
        <div className="flex gap-10 md:justify-between items-center">
          <span className="flex gap-2 items-center  text-gray-500 ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"
              />
            </svg>
          </span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 text-gray-500 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
              />
            </svg>
          </span>
        </div>
        <div className="mt-2">
          <span className="px-3 py-1 border-slate-200 border-2 rounded-lg text-xs text-gray-500">
            {post?.fields?.category}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
